import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { useMe } from "@/context/MeContext";

const PUBLIC_LINKS = [
  { to: "/explore", label: "Explore" },
  { to: "/guide-me", label: "Guide me" },
  { to: "/escapes/weekend-getaways", label: "Weekends" },
  { to: "/escapes/women-only-retreats", label: "Women-only" },
  { to: "/escapes/outbound-escapes", label: "Outbound" },
];

const linkCls = ({ isActive }) =>
  `text-sm transition-colors duration-200 hover:text-secondary ${isActive ? "text-secondary" : "text-foreground/80"}`;

function useNavLinks() {
  const { me } = useMe();
  const links = [...PUBLIC_LINKS];
  if (me) links.push({ to: "/trips", label: "My trips" });
  if (me && me.role !== "seeker") links.push({ to: "/partner", label: "Partner workspace" });
  if (me?.role === "admin") links.push({ to: "/admin", label: "Ops" });
  return links;
}

export default function SiteHeader() {
  const links = useNavLinks();
  return (
    <header className="sticky top-0 z-40 border-b border-border/70 bg-background/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-5 md:px-8">
        <Link to="/" className="flex items-baseline gap-2" data-testid="brand-logo">
          <span className="font-display text-2xl font-semibold tracking-tight text-primary">GOSHA</span>
          <span className="hidden text-[10px] uppercase tracking-[0.25em] text-muted-foreground sm:inline">curated getaways</span>
        </Link>
        <nav className="hidden items-center gap-6 lg:flex">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkCls} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Show when="signed-out">
            <Link to="/partner" className="hidden text-sm text-muted-foreground hover:text-primary md:inline" data-testid="become-partner-link">Become a partner</Link>
            <Button asChild size="sm" className="rounded-full px-5" data-testid="header-sign-in-btn"><Link to="/sign-in">Sign in</Link></Button>
          </Show>
          <Show when="signed-in"><UserButton /></Show>
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="lg:hidden" data-testid="mobile-menu-btn"><Menu className="h-5 w-5" /></Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-background">
              <SheetTitle className="font-display text-2xl text-primary">GOSHA</SheetTitle>
              <div className="mt-8 flex flex-col gap-5">
                {links.map((l) => (
                  <NavLink key={l.to} to={l.to} className={linkCls} data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</NavLink>
                ))}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
